"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderFromShopify = orderFromShopify;
exports.orderFromSquarespace = orderFromSquarespace;
exports.userOrderEmailAddresses = userOrderEmailAddresses;
exports.orderShouldBeIgnored = orderShouldBeIgnored;
exports.orderUrlFactory = orderUrlFactory;
function addressFromShopify(address) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return `${(_a = address.first_name) !== null && _a !== void 0 ? _a : ''} ${(_b = address.last_name) !== null && _b !== void 0 ? _b : ''}
${(_c = address.company) !== null && _c !== void 0 ? _c : ''}
${(_d = address.address1) !== null && _d !== void 0 ? _d : ''}
${(_e = address.address2) !== null && _e !== void 0 ? _e : ''}
${(_f = address.city) !== null && _f !== void 0 ? _f : ''}
${(_g = address.province) !== null && _g !== void 0 ? _g : ''}
${(_h = address.zip) !== null && _h !== void 0 ? _h : ''}
${(_j = address.country_name) !== null && _j !== void 0 ? _j : ''}
`.replace(/\n\s*[\n|$]/g, '\n');
}
function addressFromSquarespace(address) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return `${(_a = address.firstName) !== null && _a !== void 0 ? _a : ''} ${(_b = address.lastName) !== null && _b !== void 0 ? _b : ''}
${(_c = address.address1) !== null && _c !== void 0 ? _c : ''}
${(_d = address.address2) !== null && _d !== void 0 ? _d : ''}
${(_e = address.city) !== null && _e !== void 0 ? _e : ''}
${(_f = address.state) !== null && _f !== void 0 ? _f : ''}
${(_g = address.postalCode) !== null && _g !== void 0 ? _g : ''}
${(_h = address.countryCode) !== null && _h !== void 0 ? _h : ''}
`.replace(/\n\s*[\n|$]/g, '\n');
}
function orderFromShopify(order) {
    return {
        source: 'shopify',
        id: order.id.toString(),
        orderNumber: order.order_number.toString(),
        createdAt: order.created_at.toDate(),
        modifiedAt: order.updated_at.toDate(),
        email: order.email,
        totalGbp: order.currency === 'GBP' ? order.total_price : 0,
        // TODO: remove refunded (and restocked!) line items from `order.refunds`
        items: order.line_items.map((item) => ({
            name: item.name,
            unitPriceGbp: order.currency === 'GBP' ? item.price : 0,
            quantity: item.quantity,
        })),
        itemCount: order.line_items.reduce((count, item) => count + item.quantity, 0),
        tags: new Set(order.tags
            .toLowerCase()
            .split(/\s*,\s*/) // tags are comma-separated but may have spaces
            .filter(Boolean) // remove empty tags
        ),
        shippingAddress: order.shipping_address
            ? addressFromShopify(order.shipping_address)
            : undefined,
        billingAddress: order.billing_address ? addressFromShopify(order.billing_address) : undefined,
    };
}
function orderFromSquarespace(order) {
    return {
        source: 'squarespace',
        id: order.id,
        orderNumber: order.orderNumber,
        createdAt: order.createdOn.toDate(),
        modifiedAt: order.modifiedOn.toDate(),
        email: order.customerEmail,
        totalGbp: order.grandTotal.currency === 'GBP' ? order.grandTotal.value : 0,
        items: order.lineItems.map((item) => ({
            name: item.productName,
            unitPriceGbp: item.unitPricePaid.currency === 'GBP' ? item.unitPricePaid.value : 0,
            quantity: item.quantity,
        })),
        itemCount: order.lineItems.reduce((count, item) => count + item.quantity, 0),
        tags: new Set(),
        shippingAddress: addressFromSquarespace(order.shippingAddress),
        billingAddress: addressFromSquarespace(order.billingAddress),
    };
}
function userOrderEmailAddresses(userEmail, user) {
    var _a;
    return new Set([userEmail, ...((_a = user === null || user === void 0 ? void 0 : user.storeEmailAddresses) !== null && _a !== void 0 ? _a : [])].filter(Boolean));
}
function orderShouldBeIgnored(order) {
    // Note that tags are always converted to lowercase by `orderFromShopify`
    return (!order.email ||
        order.tags.has('test') ||
        order.tags.has('replacement') ||
        order.tags.has('cwds') ||
        order.tags.has('freebie') ||
        order.tags.has('escape hunt'));
}
function orderUrlFactory(shopifyShopName) {
    return function orderUrl(order) {
        switch (order.source) {
            case 'shopify':
                return `https://${shopifyShopName}.myshopify.com/admin/orders/${order.id}`;
            case 'squarespace':
                return `https://tangerine-dog-ww76.squarespace.com/commerce/orders/${order.id}/authenticated`;
        }
    };
}
//# sourceMappingURL=orders.js.map